let inputInstance;

const FJInputUtil = {
    createInput: function (acceptType, onchange, multiple = false) {
        inputInstance = inputInstance || document.createElement('input');
        inputInstance.setAttribute('accept', acceptType);
        inputInstance.setAttribute('type', 'file');
        multiple && inputInstance.setAttribute('multiple', multiple);
        inputInstance.onchange = e => {
            onchange(e);
            inputInstance.value = '';
        };
        inputInstance.click();
    },
};

export default FJInputUtil;
